/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/sheets/QaPhoneAddProductSheet.tsx
 * FILE_ID: JOBHUB-QA-PHONE-ADD-PRODUCT-001
 * PURPOSE: Phone sheet for the same Add product panel the desktop toolbar uses.
 */
import { MobileSheet } from '@quotech/ui'
import { QaAddProductBody } from '../../QaAddProductControl'
import type { JobQaTabController } from '../../useJobQaTabController'

export function QaPhoneAddProductSheet({
  open,
  onClose,
  controller,
}: {
  open: boolean
  onClose: () => void
  controller: JobQaTabController
}) {
  return (
    <MobileSheet open={open} onClose={onClose} title="Add Product" sheetTestId="qa-phone-add-product-sheet" size="full">
      <div className="p-3">
        <QaAddProductBody controller={controller} />
      </div>
    </MobileSheet>
  )
}
